var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportsSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "social-media-feed__social-symbol",
    width: 195,
    height: 356,
    viewBox: "0 0 195 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1891 134.379C117.728 134.379 134.378 117.729 134.378 97.1897C134.378 76.6506 117.728 60.0005 97.1891 60.0005C76.6502 60.0005 60 76.6507 60 97.1897C60 117.729 76.6502 134.379 97.1891 134.379ZM-1.06867e-05 97.1897C-4.78459e-06 150.866 43.5131 194.379 97.1891 194.379C150.865 194.379 194.378 150.866 194.378 97.1897C194.378 43.5136 150.865 0.000486951 97.1891 0.000492853C43.513 0.000498755 -1.65888e-05 43.5136 -1.06867e-05 97.1897Z",
    fill: "#00CDD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3832 194.378L190.237 355.856L4.22559 355.856L97.3832 194.378Z",
    fill: "#0F809A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsSymbol);
export default __webpack_public_path__ + "static/media/sports-symbol.db05af41.svg";
export { ForwardRef as ReactComponent };